<template>
	<action-panel close="no" :icon="panelIcon" :links="panelLinks" :buttons="panelButtons" :style="colorStyle" @action="doAction">
		<div style="text-align:center;margin-bottom:4px"><seconds-timer :run="running" :size="running ? 'big':'normal'" v-model="timer" :created="panel.created"></seconds-timer></div>
		<action-comment v-if="!done" :panel-id="panel.id" :autosave="true" @submit="doAction('done')" :comment="panel.data.comment"></action-comment>
		<div v-else class="ap-comment-readonly">{{ panel.data.comment }}</div>
	</action-panel>
</template>

<script setup lang="ts">
import {ref, computed, CSSProperties} from "vue";
import ActionPanel from "@/ui/action-panel/ActionPanel.vue";
import {ActionPanelButton, ActionPanelLink, type TrackerPanelInstance} from "@t/ui/ActionPanel.ts";
import SecondsTimer from "@/ui/action-panel/SecondsTimer.vue";
import {SrcType} from "@t/meta/SourceType.ts";
import {injectEnv} from "@fd/Environment.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import ActionComment from "@/ui/action-panel/ActionComment.vue";

const props = defineProps<{
	panel: TrackerPanelInstance
}>();

const env = injectEnv();
const ns = useNavigationStore();
const running = computed<boolean>(() => props.panel.data.state === "TRACKING");
const done = computed<boolean>(() => props.panel.data.state === "DONE");
const timer = ref<number>(props.panel.data.seconds);

const panelIcon = computed<ActionPanelLink>(() => {
	return { icon: "stopwatch", srcType: SrcType.WORKSHEET, srcId: props.panel.data.worksheet }
});
const panelLinks = computed<ActionPanelLink[]>(() => {
	const linx:ActionPanelLink[] = [];
	if (Array.isArray(props.panel.data.links) && props.panel.data.links.length > 0) {
		linx.push(...props.panel.data.links);
	} else {
		linx.push({ title: env.msg('th.worksheet'), srcType: SrcType.WORKSHEET, srcId: props.panel.data.worksheet });
	}
	return linx;
});
const panelButtons = computed<ActionPanelButton[]>(() => {
	const dp:ActionPanelButton[] = [];
	if (!done.value) {
		if (running.value) dp.push({ icon: "track-stop", title: env.msg('tracker.pause'), action: "pause" });
		else dp.push({ icon: "track-run", title: env.msg('tracker.run'), action: "run" });
		dp.push({ icon: "checkmark-16-heavy", title: env.msg('tracker.done'), action: "done" });
	}
	return dp;
});

const colorStyle = computed<CSSProperties>(() => {
	const s: CSSProperties = {};
	s['--button-hue'] = running.value ? 120 : 210;
	s['--button-sat'] = props.panel.data.state === "DONE" ? 20 : 100;
	return s;
});

function doAction(action:string, arg?:any) {
	if (action === "done") {
		ns.panelAction(props.panel.id, "done", {}, { comment: props.panel.data.comment });
	} else {
		ns.panelAction(props.panel.id, action);
	}
}
</script>

<style>

</style>